import React from 'react';
import { SignIn } from '@clerk/clerk-react';

const CustomLoginPage: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col md:flex-row">
      {/* Left half: Form */}
      <div className="w-full md:w-1/2 flex items-center justify-center p-6 md:p-12">
        <div className="w-full max-w-md">
          <div className="space-y-8">
            {/* Header */}
            <div>
              <img 
                src="https://approvia.io/wp-content/uploads/2023/09/Untitled-2@0.5x-1024x226.png" 
                alt="Approvia Logo" 
                className="h-12 mb-6"
              />
              <h1 className="text-4xl font-bold text-gray-900 mb-4">
                Welcome Back
              </h1>
              <p className="text-xl text-gray-600">
                Sign in to your account and continue your journey.
              </p>
            </div>

            {/* Clerk SignIn Component */}
            <div>
              <SignIn
                appearance={{
                  elements: {
                    rootBox: "w-full",
                    card: "bg-transparent shadow-none border-none p-[15px]",
                    headerTitle: "hidden",
                    headerSubtitle: "hidden",
                    logoBox: "hidden",
                    footer: "hidden",
                  },
                }}
                redirectUrl="/"
                signUpUrl="/sign-up"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Right half: Background Image - Hidden on mobile */}
      <div className="hidden md:block w-1/2 bg-cover bg-center bg-no-repeat rounded-3xl shadow-2xl m-8" 
           style={{ backgroundImage: `url(https://images.unsplash.com/photo-1642615835477-d303d7dc9ee9?w=2160&q=80)` }}>
      </div>
    </div>
  );
};

export default CustomLoginPage; 